<template>
	<div class="login-view">
		<div class="form">
			<input v-model="email"
			       @keyup.enter="onLogin()"
			       placeholder="Email" />
			<input v-model="password"
			       @keyup.enter="onLogin()"
			       placeholder="Password"
			       type="password" />
			<c-button tag="button"
			          class="mt-30"
			          @click="onLogin()"
			          type="submit"
			          :disabled="inProgress">
				{{ inProgress ? 'Loading ...' : 'Log In' }}
			</c-button>
		</div>
		<div class="h2 my-35">
			or
		</div>
		<c-button tag="a"
		          @click="$ga.event('Skaavok', 'Login with discord')"
		          :href="discordRedirectUri">
			<img src="@/assets/discord.svg" height="28px" width="28px" class="mr-10" />
			Log in using Discord
		</c-button>
		<div class="mt-30">
			<router-link to="/registration">
				Or you can create account
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			discordRedirectUri: process.env.VUE_APP_DISCORD_REDIRECT_URL,
			email: '',
			name: '',
			password: '',
			inProgress: false,
		};
	},
	methods: {
		onLogin() {
			this.inProgress = true;
			this.$store.dispatch('userLogin', {
				email: this.email,
				password: this.password,
			})
				.then(() => {
					this.$router.push({ name: 'DayView' });
					this.inProgress = false;
				})
				.catch((e) => {
					if (e.response.status === 400) {
						this.$notify({
							group: 'system',
							title: 'Important message!',
							text: e.response.data.message,
							type: 'error',
						});
					}
					this.inProgress = false;
				});
		},
	},
	mounted() {
		if (this.$cookies.get('userToken')) {
			this.$router.push({ name: 'DayView' });
		}
	},
};
</script>

<style lang="scss">
	.login-view{
		padding: 80px 30px 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		max-width: 400px;
		margin: auto;
		min-height: 70vh;
		.form{
			display: flex;
			flex-direction: column;
			width: 100%;
			input{
				font-size: 18px;
				padding: 10px;
				margin-bottom: 15px;
				border: 1px solid #ddd;
			}
		}
	}
</style>
